import React from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';

import {
  container,
  link,
  inner,
  title1,
  title2,
  altTitle,
  textInner,
  titleSeparate,
} from './styles.module.scss';

const StretchBanner = () => {
  return (
    <div className={container}>
      <div className="scr-wrap">
        <div className={inner}>
          <div className={textInner}>
            <p className={classnames(title1, titleSeparate)}>Webinar</p>
            <p className={classnames('src-reg', title2, titleSeparate)}>
              Insights on Omnichannel Strategy and CX in Pharma
            </p>
            <p className={classnames('src-reg', title2, altTitle)}>
              {' '}
              Michal Myszkowski, CX Lead of MER at MSD
            </p>
          </div>

          <Link
            to={`/webinar/insights-on-omnishannel-strategy-and-cx-in-pharma/`}
            className={link}
            id="link-stretch-banner"
          >
            Register Now
          </Link>
        </div>
      </div>
    </div>
  );
};

export default StretchBanner;
